import React from "react";
import { Eye, Pencil, Trash } from "lucide-react";
import { Switch } from "@mui/material";

const BrandListItem = ({
  brand,
  onView,
  onEdit,
  onDelete,
  onRestore,
  isDeleted,
  onStatusChange,
  isStatusUpdating,
}) => {
  return (
    <div
      className={`flex items-center px-6 py-4 hover:bg-gray-50 border-b last:border-b-0 ${
        isDeleted ? "opacity-75 bg-gray-50" : ""
      }`}>
      <div className="flex items-center flex-1">
        <img
          src={brand.image || require("../../../../../assets/brand.png")}
          alt={brand.name}
          className="w-12 h-12 rounded-full object-cover mr-4"
          onError={e => {
            e.target.onerror = null;
            e.target.src = require("../../../../../assets/brand.png");
          }}
        />

        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="font-medium text-gray-900">{brand.name}</h3>
            <span
              className={`px-2.5 py-0.5 text-xs font-medium rounded-full 
              ${
                brand.status === "ACTIVE"
                  ? "bg-green-50 text-green-700"
                  : "bg-red-50 text-red-700"
              }`}>
              {brand.status}
            </span>
            <span
              className={`px-2.5 py-0.5 text-xs font-medium rounded-full 
              ${
                brand.brand_type === "DOMESTIC"
                  ? "bg-blue-50 text-blue-700"
                  : "bg-orange-50 text-orange-700"
              }`}>
              {brand.brand_type === "DOMESTIC" ? "Domestic" : "International"}
            </span>
          </div>
          <div className="flex items-center gap-3 mt-1">
            <span className="text-sm text-gray-500">
              {brand.metadata?.products_count || 0} Products
            </span>
            {brand.orderValidation?.validationType === "MOQ_MOV" && (
              <>
                <span className="text-gray-300">•</span>
                <span className="text-sm text-gray-500">
                  MOQ: {brand.orderValidation.minOrderQty || "N/A"}
                </span>
                <span className="text-gray-300">•</span>
                <span className="text-sm text-gray-500">
                  MOV: ₹{brand.orderValidation.minOrderValue || "N/A"}
                </span>
                <span className="text-gray-300">•</span>
                <span className="text-sm text-gray-500">
                  {brand.orderValidation.validationCondition === "BOTH"
                    ? "Both required"
                    : "Any one required"}
                </span>
              </>
            )}
          </div>
          {brand.description && (
            <p className="text-sm text-gray-500 mt-1 line-clamp-1">
              {brand.description}
            </p>
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-4">
          <div className="flex items-center">
            <Switch
              checked={brand.status === "ACTIVE"}
              onChange={() => !isStatusUpdating && onStatusChange(brand)}
              disabled={isStatusUpdating}
              size="small"
              sx={{
                "&.Mui-checked": {
                  color: "#5652B0",
                },
                "&.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#5652B0",
                },
              }}
            />
          </div>
          <button
            onClick={() => onView(brand)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            title="View Details">
            <Eye size={18} className="text-gray-600" />
          </button>
          <button
            onClick={() => onEdit(brand)}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            title="Edit Brand">
            <Pencil size={18} className="text-gray-600" />
          </button>
          {isDeleted ? (
            <button
              onClick={() => onRestore(brand)}
              className="px-3 py-1 text-sm text-green-600 hover:text-green-700 font-medium">
              Restore Brand
            </button>
          ) : (
            <button
              onClick={() => onDelete(brand)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              title="Delete Brand">
              <Trash size={18} className="text-red-500" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default BrandListItem;
